import { mergeMap } from 'rxjs/operators';
import { EmailService } from './integrations/email/email.service';
import { NoteService } from './notes/note.service';
import { forkJoin, Observable, of } from 'rxjs';
import { OrgModel } from './../store/storeModels/user.model';
import { UserModel } from 'src/app/store/storeModels/user.model';
import { Store } from "@ngrx/store";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { DealFilterModel, DealModel } from "../models/deal.model";
import { Endpoints } from "../shared/config/endpoints";
import DateUtils from "../utils/date";
import { GeneralService } from "./general.service";
import { AppState } from "../store/app.state";
import { map } from 'rxjs/operators';

export interface DealFilterFormatModel {
  dateFilter?: any;
  creatorId?: any;
  client?: any;
  closeDate?: any;
  value?: any;
  winPro?: any;
  profileScore?: any;
  status?: any;
  archiveFlag?: number,
  age?: any,
  forecastDate?: any;
  salesPerson?: any;
  dateToFilterBy?: string;
  forecastStatus?:any
}
@Injectable({
  providedIn: "root",
})
export class DealsService {
  orgId = 0;
  teamId = "0";
  user: UserModel;
  org: OrgModel
  constructor(
    private http: HttpClient,
    private endpoints: Endpoints,
    private gs: GeneralService,
    private noteSrv: NoteService,
    private emailSrv: EmailService,
    store: Store<AppState>
  ) {
    store.select("userInfo").subscribe((info) => {
      this.orgId = info.organization.id;
      this.org = info.organization;
      this.user = info.user;
      this.teamId = info.user.teamID;
    });
  }
  dateUtil = new DateUtils();
  settingApi = this.endpoints.settingsUrl + "/settingsservice-notch-crm";
  localApi = "http://10.10.100.79:8080/salesservice";
  salesUrl = this.endpoints.salesUrl;
  winningProb = (Math.random() * 50).toFixed(2);
  profileScore = (Math.random() * 50).toFixed();

  createDeal(form: DealModel) {
    const body = {
      ...form,
      srcID: form.src.split('+')[0],
      srcName: form.src.split('+')[1],
      closeDate: this.dateUtil.getTimeStp(form.closeDate) + "",
      clientID: form.client.id,
      clientName: form.client.name,
      clientEmail: form.client.email,
      creatorID: (form.creatorID as any).id,
      source: (form.creatorID as any).name,
      hasQuote: false,
      orgID: this.orgId,
      profileScore: this.profileScore,
      salesCompetitors: form.salesCompetitors.map((sales) => ({
        name: sales.name,
        id: sales.id,
      })),
      salesProcessID: form.salesProcessName.split("+")[0],
      salesProcessName: form.salesProcessName.split("+")[1],
      stageID: form.currStage.split("+")[0],
      currStage: form.currStage.split("+")[1],
      winningProb: this.winningProb,
      actionBy: `${this.user.firstName} ${this.user.lastName}`,
      orgName: this.org.name
    };
    return this.http.post(this.salesUrl + "/newDeal", body);
  }

  fetchDeals(teamId?, filter?: DealFilterFormatModel, archiveFlag?: number): Observable<any[]> {
    let endpoint = "/getTeamDeals";

    const dateFilter = filter && filter.dateFilter ? filter.dateFilter : null;
    let body = {
      ...this.dateUtil.getDateFilter(dateFilter),
      contactType: "",
      filter: "",
      dealValueFrom: "",
      dealValueTo: "",
      orgID: this.orgId,
      salesProcessID: "",
      creatorID: null,
      teamID: teamId ? teamId : [this.teamId],
      from: "",
      to: "",
      archiveFlag: archiveFlag || 0,
      dateToFilterBy: filter && filter.dateToFilterBy ? filter.dateToFilterBy :  'createdDate'
    };
    body = filter && filter.salesPerson ? { ...body, creatorID: filter.salesPerson.ids } : body;

    let statusFilter = null;

    if (filter) {
      const {
        forecastStatus,
        closeDate,
        client,
        creatorId,
        value,
        profileScore,
        winPro,
        status,
        age,
        forecastDate,
      } = filter;

      statusFilter = status;

      const hasOtherFilters = creatorId || client || closeDate || forecastDate ||
                              forecastStatus || value || age || winPro || profileScore;

      if (creatorId) {
        body = { ...body, filter: creatorId.owner };
        endpoint = "/getCreatorDeals";
      }
      if (client) {
        body = { ...body, filter: client.client.id, contactType: client.type };
        endpoint = "/getContactDeals";
      }
      if (closeDate) {
        const dateFit = { ...this.dateUtil.getDateFilter(closeDate) };
        body = { ...body, ...dateFit };
        endpoint = "/getCloseDateTeamDeals";
      }
      if (forecastDate) {
        body = { ...body, filter: forecastDate.forecastStatus };
        endpoint = "/getDealsByForecastStatus";
      }
      if (forecastStatus) {
        body = { ...body,filter:forecastStatus};
        endpoint = "/getDealsByForecastStatus";
      }
      if (value) {
        body = { ...body, dealValueFrom: value.from, dealValueTo: value.to };
        endpoint = "/getAmountDeals";
      }
      if (age) {
        body = { ...body, endDate: age.from, startDate: age.to };
        endpoint = "/getDealsByAge";
      }
      if (winPro) {
        body = { ...body, from: winPro.from, to: winPro.to };
        endpoint = "/getWinningProbDeals";
      }
      if (profileScore) {
        body = { ...body, from: profileScore.from, to: profileScore.to };
        endpoint = "/getProfileScoreDeals";
      }

      if (status !== undefined && status !== null && !hasOtherFilters) {
        endpoint = "/getDealsByStatus";
        body = { ...body, filter: status };
      }
    }

    return this.http.post<any[]>(this.salesUrl + endpoint, body).pipe(
      map((deals: any[]) => {
        if (statusFilter !== null && statusFilter !== undefined) {
          return deals.filter(deal => {
            const dealStatus = this.getDealStatusString(deal);
            return dealStatus === statusFilter;
          });
        }
        return deals;
      })
    );
  }

  private getDealStatusString(deal: any): string {
    // status: 0 = OPEN, 1 = LOST, 2 = WON
    if (deal.status === 2 || deal.currStage === 'Won') {
      return 'WON';
    } else if (deal.status === 1 || deal.currStage === 'Lost') {
      return 'LOST';
    } else {
      return 'OPEN';
    }
  }
  fetchStageConversion() {
    return this.http.get('https://62cceb3b-f3a2-46e9-a261-dc99de1790e8.mock.pstmn.io')
  }

  getAllContactDeals(type, clientId) {
    let url = this.salesUrl + `/${this.orgId}/${type}/${clientId}/getAllContactDeals`;
    return this.http.get(url);
  }
  fetchTaskAndEmailsByDealsId(deals) {
    const dealsId = deals.map(deal => deal.code);
    const getNotesTasks = this.noteSrv.getRecentNoteActivity(`${dealsId}`);
    const getEmails = this.emailSrv.getLastActivity({'dealId': `${dealsId}`});
    return forkJoin([getEmails, getNotesTasks]).pipe(map(([emails, notesTasks]) => {
      return this.mergeDealsEmailTasksNote({dealsList: deals, notesTasks, emails})
    }))
  }
  mergeDealsEmailTasksNote({dealsList, notesTasks, emails}) {
    let dealActivities = {};
    let deals = {};
    notesTasks.forEach(activity => {
      dealActivities[activity.dealCode] = { ...activity };
    });
    emails.forEach(activity => {
      dealActivities[activity.dealCode] = { ...dealActivities[activity.dealCode], dealCode: activity.dealCode, lastEmailAgo: activity.lastDaysAgo};
    });
    dealsList.forEach( deal => {
      deals[deal.code] = { ...deal };
      dealActivities[deal.code] = { ...dealActivities[deal.code], lastStageChange: deal.lastStageChange};
    });
    Object.keys(dealActivities).forEach( dealCode => {
      deals[dealCode] = {
        ...deals[dealCode],
        ...dealActivities[dealCode],
        lastActivityDuration: this.getLastValue(dealActivities[dealCode])
      };
    });
    const result = Object.keys(deals).map((code) => deals[code]);
    return result;
  }

  fetchDealsLastActivity(teamId?, filter?: DealFilterFormatModel, archiveFlag?: number) {
    const actDeals = this.fetchDeals(teamId, filter, archiveFlag).pipe(mergeMap((deals) => {
      if(deals.length) {
        return this.fetchTaskAndEmailsByDealsId(deals)
      } else {
        return of(deals)
      }
    }))
    return actDeals;
  }

  private getLastValue(obj: object) {
    let times = [];
    Object.values(obj).forEach((el, i) => {
      if (el < 0) return;
      times.push(el);
    });

    return times.reduce((latest, e) => {
      return e < latest ? e : latest;
    }, Number.MAX_SAFE_INTEGER);
  }


  getSalesPersonsDeals(id) {
    return this.http.get(
      this.salesUrl + `/${this.orgId}/${id}/getAllCreatorDeals`
    );
  }

  updateDeal(body) {
    const name = `${this.user.firstName} ${this.user.lastName}`
    const payload = {
      ...body,
      actionBy: name,
      orgName: this.org.name
    }
    return this.http.post(this.salesUrl + "/editDeal", payload);
  }

  fetchDeal(id) {
    return this.http.get(this.salesUrl + `/${id}` + "/getDeal");
  }

  fetchSaleCompetitor() {
    return this.http.get(
      this.settingApi + `/${this.orgId}/getSalesCompetitorByCompany`
    );
  }

  fetchAllProducts() {
    return this.http.get(
      this.settingApi + `/${this.orgId}/getProductsByCompany`
    );
  }

  fetchSalesProcess() {
    return this.http.get(
      this.settingApi + `/${this.orgId}/getDealsPipelineWorkflows`
    );
  }
  fetchUsersWorkflow(userID = this.user.id) {
    return this.http.get(`${this.settingApi}/${this.orgId}/${userID}/getUserDealsWorkflows`)
  }
  fetchOrgPiplelineWorkflow() {
    return this.http.get(
      `${this.settingApi}/${this.orgId}/getOrgDealsPipelineWorkflows`
    );
  }
  fetchTeamPipelineWorkflow(teamID: number) {
    return this.http.get(
      `${this.settingApi}/${this.orgId}/${teamID}/getTeamDealsPipelineWorkflows`
    );
  }
  fetchUserPipelineworkflow(userID = this.user.id) {
    return this.http.get(
      `${this.settingApi}/${this.orgId}/${userID}/getUserDealsPipelineWorkflows`
    );
  }
  fetchTeamDealsWorkflow(teamID) {
    return this.http.get(
      `${this.settingApi}/${this.orgId}/${teamID}/getTeamDealsWorkflows`
    );
  }

  fetchStages(processId) {
    return this.http.get(
      this.settingApi + `/${processId}/getDealsPipelineStages`
    );
  }

  changeStage(form) {
    let body = {
      ...form,
      actionBy: `${this.user.firstName} ${this.user.lastName}`,
      orgName: this.org.name,
      status: 0
    };
    if (form.stageName === "Won") {
      body = { ...body, status: 2 };
    }
    if (form.stageName === "Lost") {
      body = { ...body, status: 1 };
    }

    return this.http.post(this.salesUrl + "/changeStage", body);
  }

  fetchPipelineDeals(processId, teamId?, filter?) {
    const closeDate = filter && filter.closeDate ? filter.closeDate : null;
    const dateFilter = filter && filter.dateFilter ? filter.dateFilter : null;

    const dateToUse = closeDate || dateFilter;

    const processedDates = this.dateUtil.getDateFilter(dateToUse);

    const endDate = processedDates.endDate;
    const startDate = processedDates.startDate;
    const archiveFlag = filter && filter.archiveFlag !== undefined ? filter.archiveFlag : 0;

    let endpoint = closeDate ? "/getCloseDatePipelineDeals" : "/getPipelineDeals";

    let body = {
      endDate,
      filter: "",
      orgID: this.orgId,
      salesProcessID: processId,
      startDate,
      teamID: teamId ? teamId : this.teamId,
      creatorID: [],
      archiveFlag: archiveFlag,
    };
    body = {
      ...body,
      teamID: Array.isArray(teamId) ? [...body.teamID] : [body.teamID],
    };
    if (filter) {
      if (filter.salesperson) {
        endpoint = "/getCreatorPipelineDeals";
        body = { ...body, creatorID: filter.salesperson };
      }
    }
    return this.http.post(this.salesUrl + endpoint, body);
  }

  createFilter(type: 'new' | 'edit', body) {
    const newBody = this.dateUtil.convertDatesToTsInObj(body);
    const data = {
      ...newBody,
      archiveFlag: newBody.archiveFlag ? Number(newBody.archiveFlag) : newBody.archiveFlag,
      clientID: newBody.client && newBody.client.id ? newBody.client.id : 0,
      clientName: newBody.client && newBody.client.name ? newBody.client.name : "",
      clientType: newBody.client && newBody.client.name ? "CLIENT" : "",
      dealOwnerID: newBody.dealOwner && newBody.dealOwner.id ? newBody.dealOwner.id : 0,
      dealOwnerName: newBody.dealOwner && newBody.dealOwner.name ? newBody.dealOwner.name : "",
      orgID: this.orgId,
      teamID: this.user.id,
    };
    return this.http.post(this.salesUrl + `/${type}DealsCustomFilter`, data);
  }


  deleteFilter(filter) {
    return this.http.delete(
      this.salesUrl + `/${filter.id}/deleteDealsCustomFilter`
    );
  }

  fetchFilters(teamId, archiveFlag = 0) {
    let teamID = teamId === 'All' ? this.user.teamID : teamId;
    teamID = this.user.id
    return this.http.get(
      this.salesUrl +
      `/${this.orgId}/${teamID}/getDealsCustomFilters`
    );
  }

  editFilter(filter: any) {
    const body = {
      ...filter,
      name: filter.name,
      dealValueFrom: '',
      dealValueTo: '',
      dealOwnerID: filter.dealOwnerName && filter.dealOwnerName.id ? filter.dealOwnerName.id : 0,
      dealOwnerName: filter.dealOwnerName && filter.dealOwnerName.name ? filter.dealOwnerName.name : "",
      clientType: filter.clientName ? "CLIENT" : "",
      clientID: filter.clientName && filter.clientName.id ? filter.clientName.id : 0,
      clientName: filter.clientName && filter.clientName.name ? filter.clientName.name : "",
    };
    return this.http.post(this.salesUrl + "/editDealsCustomFilter", body);
  }

  fetchFilteredDeals(filterId, teamIds: any[]) {
    const url = this.salesUrl + `/${filterId}/${teamIds}/getFilteredDeals`;
    return this.http.get(url);
  }

  fetchFilteredPipelineDeals(filterId: number, salesProcessID: string, teamIds: any[]) {
    const teamIDsParam = Array.isArray(teamIds) ? teamIds.join(',') : teamIds;
    const url = this.salesUrl + `/${filterId}/${salesProcessID}/getFilteredPipelineDeals?teamIDs=${teamIDsParam}`;
    return this.http.get(url);
  }

  fetchUnifiedFilteredDeals(filterParams: any, teamIds: any[], archiveFlag: number = 0): Observable<any> {
    const body: any = {
      orgID: this.orgId.toString(),
      teamIDs: teamIds.map(id => id.toString()),
      archiveFlag: archiveFlag,
      pageNumber: 0,
      pageSize: 50,
      sortBy: "createdDate",
      sortDirection: "DESC"
    };

    if (filterParams.status) {
      const statusMap = { 'OPEN': 0, 'LOST': 1, 'WON': 2 };
      body.status = statusMap[filterParams.status];
    }

    if (filterParams.creatorId && filterParams.creatorId.owner) {
      body.creatorIDs = [filterParams.creatorId.owner.toString()];
    }

    if (filterParams.client && filterParams.client.client && filterParams.client.client.id) {
      body.contactOrClientID = filterParams.client.client.id.toString();
      body.contactType = filterParams.client.type === 'Client' ? 'CLIENT' : 'CONTACT';
    }

    if (filterParams.dateFilter) {
      const dates = this.dateUtil.getDateFilter(filterParams.dateFilter);
      body.startDate = dates.startDate;
      body.endDate = dates.endDate;
      body.dateFilterField = "createdDate";
    }

    if (filterParams.closeDate) {
      const dates = this.dateUtil.getDateFilter(filterParams.closeDate);
      body.startDate = dates.startDate;
      body.endDate = dates.endDate;
      body.dateFilterField = "actualClosedDate";
      body.sortBy = "actualClosedDate";
    }

    if (filterParams.forecastStatus) {
      body.forecastFilter = filterParams.forecastStatus;
    }

    if (filterParams.value && (filterParams.value.from || filterParams.value.to)) {
      if (filterParams.value.from) {
        body.dealValueFrom = parseFloat(filterParams.value.from);
      }
      if (filterParams.value.to) {
        body.dealValueTo = parseFloat(filterParams.value.to);
      }
    }

    if (filterParams.age) {
      if (filterParams.age.ageFrom !== undefined && filterParams.age.ageFrom !== null) {
        body.ageFrom = parseInt(filterParams.age.ageFrom.toString());
      }
      if (filterParams.age.ageTo !== undefined && filterParams.age.ageTo !== null) {
        body.ageTo = parseInt(filterParams.age.ageTo.toString());
      }
    }

    return this.http.post(this.salesUrl + '/getFilteredDeals', body).pipe(
      map((response: any) => {
        return response.deals || [];
      })
    );
  }

  fetchUnifiedFilteredPipelineDeals(processId: any, filterParams: any, teamIds: any[], archiveFlag: number = 0): Observable<any> {
    const body: any = {
      orgID: this.orgId.toString(),
      teamIDs: teamIds.map(id => id.toString()),
      archiveFlag: archiveFlag,
      salesProcessID: processId.toString(),
      pageNumber: 0,
      pageSize: 50,
      sortBy: "createdDate",
      sortDirection: "DESC"
    };

    if (filterParams.status) {
      const statusMap = { 'OPEN': 0, 'LOST': 1, 'WON': 2 };
      body.status = statusMap[filterParams.status];
    }

    if (filterParams.creatorId && filterParams.creatorId.owner) {
      body.creatorIDs = [filterParams.creatorId.owner.toString()];
    }

    if (filterParams.client && filterParams.client.client && filterParams.client.client.id) {
      body.contactOrClientID = filterParams.client.client.id.toString();
      body.contactType = filterParams.client.type === 'Client' ? 'CLIENT' : 'CONTACT';
    }

    if (filterParams.dateFilter) {
      const dates = this.dateUtil.getDateFilter(filterParams.dateFilter);
      body.startDate = dates.startDate;
      body.endDate = dates.endDate;
      body.dateFilterField = "createdDate";
    }

    if (filterParams.closeDate) {
      const dates = this.dateUtil.getDateFilter(filterParams.closeDate);
      body.startDate = dates.startDate;
      body.endDate = dates.endDate;
      body.dateFilterField = "actualClosedDate";
      body.sortBy = "actualClosedDate";
    }

    if (filterParams.forecastStatus) {
      body.forecastFilter = filterParams.forecastStatus;
    }

    if (filterParams.value && (filterParams.value.from || filterParams.value.to)) {
      if (filterParams.value.from) {
        body.dealValueFrom = parseFloat(filterParams.value.from);
      }
      if (filterParams.value.to) {
        body.dealValueTo = parseFloat(filterParams.value.to);
      }
    }

    if (filterParams.age) {
      if (filterParams.age.ageFrom !== undefined && filterParams.age.ageFrom !== null) {
        body.ageFrom = parseInt(filterParams.age.ageFrom.toString());
      }
      if (filterParams.age.ageTo !== undefined && filterParams.age.ageTo !== null) {
        body.ageTo = parseInt(filterParams.age.ageTo.toString());
      }
    }

    return this.http.post(this.salesUrl + '/getFilteredPipelineDeals', body).pipe(
      map((response: any) => {
        return response.pipelineDeals || response;
      })
    );
  }

  fetchMultiDeals(ids: any[], teamIDs, archiveFlag = 0) {
    return this.http.get(this.salesUrl + `/${ids.toString() || 0}/${teamIDs}/${archiveFlag}/getMultiDeals`);
  }

  getMultipleDeals(ids, type) {
    return this.http.get(
      this.salesUrl + `/${ids}/${type}/${this.orgId}/getMultipleDeals`
    );
  }
  archiveDeal(code) {
    return this.http.post(this.salesUrl + `/${code}/changeArchiveStatus`, {})
  }
  getDealsStatusStatistics(payload: { endDate?: any, startDate?: any, status?: number, filter?, teamID?: any[] }): Observable<any[]> {
    const { endDate, startDate } = payload
    const body = {
      orgID: this.org.id,
      filter: 'SALESPERSON',
      teamID: [],
      status: 0,
      ...payload,
      ...this.dateUtil.getDateFilter({ endDate, startDate }),
    }
    return this.http.post<any[]>(`${this.salesUrl}/getDealsStatusStatistics`, body)
  }
  getAllDealsStatusStatistics(payload: { endDate?: any, startDate?: any, status?: number, filter?, teamID?: any[] }) {
    const All = [
      this.getDealsStatusStatistics({...payload, status: 0}),
      this.getDealsStatusStatistics({...payload, status: 1}),
      this.getDealsStatusStatistics({...payload, status: 2}),
    ]
    return forkJoin(All).pipe(map(([open, won, lost]) => {
      return [...open, ...won, ...lost]

    }))
  }

  fetchDealAgeStatistics(payload: { endDate?: any, startDate?: any, status?: number, id?: any, type?: number }): Observable<any[]> {
    const { endDate, startDate, id, type } = payload
    const body = {
      orgID: this.org.id,
      status: 2,
      id: id || [this.user.id],
      type: type,
      ...this.dateUtil.getDateFilter({ endDate, startDate }),
    }
    return this.http.post<any[]>(`${this.salesUrl}/getDealsAgeStatistics`, body)
  }
  fetchStagesToClosure(stageIds: any[], filter?: { dateFilter?: any, status: number }) {
    const dateFilter = filter && filter.dateFilter ? filter.dateFilter : null;
    const body = {
      ...this.dateUtil.getDateFilter(dateFilter),
      orgID: this.org.id,
      status: filter.status || 0,
      id: [...stageIds]
    }
    return this.http.post(`${this.salesUrl}/getStageToClosureStats`, body)
  }

  fetchDealsStatusPercentage(payload: { endDate?: any, startDate?: any, status?: number, id?: any, type?: number }): Observable<any[]> {
    if (!payload) return;
    const { startDate, status, id, type } = payload
    const body = {
      orgID: this.org.id,
      status: status,
      id: id || [this.user.id],
      type: type,
      startDate: startDate,
    }
    return this.http.post<any[]>(`${this.salesUrl}/getDealsStatusPercentage`, body)
  }

  fetchTotalWonAndLostStats(payload: { endDate?: any, startDate?: any, status?: number, id?: any, type?: number }): Observable<any[]> {
    if (!payload) return;
    const { startDate, id, type } = payload
    const body = {
      orgID: this.org.id,
      id: id || [this.user.id],
      type: type,
      startDate: startDate,
    }
    return this.http.post<any[]>(`${this.salesUrl}/getTotalWonAndLostStats`, body)
  }

  fetchSeparateTotalWonAndLostStats(payload: { endDate?: any, startDate?: any, status?: number, id?: any, type?: number }): Observable<any[]> {
    if (!payload) return;
    const { startDate, id, type } = payload
    const body = {
      orgID: this.org.id,
      id: id || [this.user.id],
      type: type,
      startDate: startDate,
    }
    return this.http.post<any[]>(`${this.salesUrl}/getSeparateTotalWonAndLostStats`, body)
  }

  fetchStageDurStats(stageIds: any[]): Observable<any[]> {
    return this.http.get<any[]>(`${this.salesUrl}/getStageDurationStats/${stageIds}`)
  }
}
